module.exports = __webpack_public_path__ + "static/media/sdg_icon_7.7ed0e56c.png";